<template>
  <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card color="red lighten-4">
        <v-toolbar color="purple lighten-4">
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Editar Datos Empleado</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="4" sm="2" md="2">
              <h6>Legajo: {{ legajo }}</h6>
            </v-col>
            <v-col cols="6" sm="4" md="4">
              <h6>Nombre: {{ nombre }}</h6>
            </v-col>
            <v-col cols="4" sm="3" md="3">
              <h6>Fecha Nacimiento: {{ fnacimiento }}</h6>
            </v-col>
            <v-col cols="4" sm="3" md="3">
              <h6>DNI: {{ dni }}</h6>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4" md="4">
              <v-text-field label="Grupo Sanguíneo" dense v-model="grupo">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field label="Dirección" dense v-model="direccion">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field label="Teléfono Particular" dense v-model="telpersonal">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4" md="4">
              <v-text-field label="Obra Social" dense v-model="obrasocial"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field label="N° de Afiliado" dense v-model="afiliado">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field label="Tel O. Social" dense v-model="telosocial">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <v-textarea label="Contacto " dense v-model="contacto" rows="2">
              </v-textarea>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-textarea label="Antecedentes Médicos" dense rows="2" auto-grow v-model="antmed">
              </v-textarea>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-textarea label="Antecendentes Quirúrgicos" rows="2" auto-grow dense v-model="antquir">
              </v-textarea>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-textarea label="Inmunizaciones" rows="2" auto-grow dense v-model="inmun">
              </v-textarea>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-textarea label="Accidentes " rows="2" auto-grow dense v-model="accidente">
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card color="red lighten-5">
        <v-card-title>
          <v-row dense>
            <v-col cols="6" sm="6" md="6">
              Exámen Preocupacional
            </v-col>
            <v-col cols="3" sm="3" md="3">
            </v-col>
            <v-col cols="3" sm="3" md="3">
              <v-text-field label="Fecha preocupacional" dense v-model="fecha">
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-textarea label="Observaciones" dense rows="2" auto-grow v-model="observ">
              </v-textarea>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-textarea label="Limitaciones" rows="2" auto-grow dense v-model="limitaciones">
              </v-textarea>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" sm="4" md="4">
              <v-select dense v-model="riesgo" :items="listadoriesgo" label="Riesgo" item-text="nombre"
                item-value="codigo"></v-select>
            </v-col>
            <v-col cols="6" sm="4" md="4">
              <v-text-field label="Otros riesgos" dense v-model="otrosriesgos">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="4" md="4">
              <v-select dense v-model="epp" :items="listadoepp" label="EPP a utilizar" item-text="nombre"
                item-value="codigo"></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-radio-group v-model="periodico" label="Exámen Periódico" row dense>
                <v-radio label="SI" value="SI" color="red darken-2"></v-radio>
                <v-radio label="NO" value="NO" color="red darken-2"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field label="Frecuencia Exámen Periódico" dense v-model="frecuencia"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card color="purple" dark tile>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="!valid" @click.stop="guardarDatospersonal">Guardar</v-btn>

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<style lang="scss">
.v-input--radio-group__input {
  label {
    margin: 0 !important;
  }
}
</style>
<script>
import axios from "../../../src/axios-auth";
import moment from "moment";
export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    legajo: "",
    dni: "",
    nombre: "",
    fnacimiento: "",
    grupo: "",
    direccion: "",
    telpersonal: "",
    obrasocial: "",
    afiliado: "",
    telosocial: "",
    contacto: "",
    antmed: "",
    antquir: "",
    accidente: "",
    inmun: "",
    fecha: "",
    preocupacional: "NO",
    observ: "",
    limitaciones: "",
    riesgo: "",
    otrosriesgos: "",
    epp: "",
    periodico: "NO",
    frecuencia: "",
    listadoriesgo: [
      { nombre: "Ninguno", codigo: "N" },
      { nombre: "80006", codigo: "80006" },
      { nombre: "80010", codigo: "80010" },
      { nombre: "90001", codigo: "90001" },],
    listadoepp: [
      { nombre: "Ninguno", codigo: "Ninguno" },
      { nombre: "Protector Auditivo", codigo: "Protector Auditivo" },
    ]


  }),
  computed: {
    show: {
      get() {
        this.buscarDatospersonal();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },
  props: ["visible", "leg", "id"],
  methods: {
    buscarDatospersonal() {
      const leg = this.leg;
      const id = this.id;
      if (leg != null) {
        let self = this;
        axios
          .get("/Medico/ListadoPersonal?", {
            params: {
              legajo: leg,
              nombre: "",
              grupo: "",
              obrasocial: "",
            },
          })
          .then((response) => {
            self.legajo = response.data[0].legajo;
            self.nombre = response.data[0].nombre;
            self.dni = response.data[0].dni;
            self.fnacimiento = moment(response.data[0].fnacimiento).format("DD/MM/YYYY");
            self.direccion = response.data[0].direccion;
            self.grupo = response.data[0].grupo;
            self.telpersonal = response.data[0].telpersonal;
            self.obrasocial = response.data[0].obrasocial;
            self.afiliado = response.data[0].afiliado;
            self.telosocial = response.data[0].telosocial;
            self.contacto = response.data[0].contacto;
            self.accidente = response.data[0].accidente;
            self.antmed = response.data[0].antmed;
            self.antquir = response.data[0].antquir;
            self.inmun = response.data[0].inmun;
            self.riesgo = response.data[0].riesgo;
            self.epp = response.data[0].epp;
            self.fecha = response.data[0].fecha;
            self.observ = response.data[0].observ;
            self.limitaciones = response.data[0].limitaciones;
            self.otrosriesgos = response.data[0].otrosRiesgos;
            self.periodico = response.data[0].periodico;
            self.frecuencia = response.data[0].frecuencia;
          })
          .catch((error) => {
            //self.listadotrazabilidad = [];
            console.log(error);
          });
      }
    },
    vaciarModels() { },

    guardarDatospersonal() {
      this.$swal({
        title: "Guardar Datos Personal",
        text: "¿Desea guardar los datos de la Personal?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          var datosPersonal = {
            id: this.id,
            legajo: this.leg,
            nombre: this.nombre,
            grupo: this.grupo,
            direccion: this.direccion,
            telpersonal: this.telpersonal,
            obrasocial: this.obrasocial,
            afiliado: this.afiliado,
            telosocial: this.telosocial,
            contacto: this.contacto,
            antmed: this.antmed,
            antquir: this.antquir,
            accidente: this.accidente,
            inmun: this.inmun,
            riesgo: this.riesgo,
            epp: this.epp,
            fecha: this.fecha,
            observ: this.observ,
            limitaciones: this.limitaciones,
            otrosRiesgos: this.otrosriesgos,
            periodico: this.periodico,
            frecuencia: this.frecuencia,
          };
          console.log(this.id)
          let self = this;
          axios
            .put("/Medico/ModificarPersonal", datosPersonal)
            .then((response) => {
              self.$refs.form.resetValidation();

              self.showAlert({
                icon: "success",
                title: "Datos guardados con éxito",
                vm: self,
              });
              self.vaciarModels();
              self.$emit("close");
            })
            .catch({});
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
